import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ShIconModule } from '../elements/components/icon/icon.module';

import { ContentContextLayoutComponent } from './content-context-layout/content-context-layout.component';
import { ContentContextNotificationsLayoutComponent } from './content-context-notifications-layout/content-context-notifications-layout.component';
import { DetailLayoutComponent } from './detail-layout/detail-layout.component';
import { DetailListLayoutComponent } from './detail-list-layout/detail-list-layout.component';
import { ListLayoutComponent } from './list-layout/list-layout.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
@NgModule({
    imports: [
        CommonModule,
        ShIconModule,
        ContentContextLayoutComponent,
        ContentContextNotificationsLayoutComponent,
        DetailLayoutComponent,
        DetailListLayoutComponent,
        ListLayoutComponent,
        MainLayoutComponent
    ],
    exports: [
        ContentContextLayoutComponent,
        ContentContextNotificationsLayoutComponent,
        DetailLayoutComponent,
        DetailListLayoutComponent,
        ListLayoutComponent,
        MainLayoutComponent
    ]
})
export class ShLayoutModule {}

export { ContentContextLayoutComponent } from './content-context-layout/content-context-layout.component';
export { ContentContextNotificationsLayoutComponent } from './content-context-notifications-layout/content-context-notifications-layout.component';
export { DetailLayoutComponent } from './detail-layout/detail-layout.component';
export { DetailListLayoutComponent } from './detail-list-layout/detail-list-layout.component';
export { ListLayoutComponent } from './list-layout/list-layout.component';
export { MainLayoutComponent } from './main-layout/main-layout.component';
